import clsx from "clsx";
import { Typography } from "antd";
import { useLocation } from "react-router-dom";
import React, { useMemo, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { isMobile } from "../../utils";
import { useAuth } from "../../contexts/AuthContext";
import {
  BannerAnchor,
  BannerContainer,
  CloseIcon,
  Layout,
  MainLayout,
} from "./styles";

interface IPageWrapperProps {
  header?: boolean;
  sideBar?: boolean;
  overflow?: boolean;
  page?: string;
}

const PageWrapper: React.FC<IPageWrapperProps> = ({
  children,
  sideBar,
  header,
  overflow,
}) => {
  const { pathname } = useLocation();
  const { user, expandedSidebar } = useAuth();
  const [bannerClosed, setBannerClosed] = useState(false);

  const currentPage = useMemo(
    () =>
      [
        {
          sidebar: true,
          header: true,
          path: "/",
          name: "Instruções",
          title: "",
        },
        {
          sidebar: true,
          header: true,
          path: "/conta",
          name: "Minha conta",
          title: "Minha conta",
        },
        {
          sidebar: true,
          header: true,
          path: "/clients",
          name: "Clientes",
          title: "Clientes",
        },
        {
          sidebar: true,
          header: true,
          path: "/darf",
          name: "Envio de DARF",
          title: "Envio de DARF",
        },
        {
          sidebar: true,
          header: true,
          path: "/professionals",
          name: "Profissionais",
          title: "Profissionais",
        },
        {
          sidebar: true,
          header: true,
          path: "/earnings",
          name: "Faturamento",
          title: "",
        },
        {
          sidebar: true,
          header: true,
          path: "/regulacao",
          name: "Regulação",
          title: "",
        },
        {
          sidebar: true,
          header: true,
          path: "/p/cadastrar",
          name: "Cadastre-se",
          title: "Cadastre-se",
        },
        {
          sidebar: true,
          header: true,
          path: "/p/login",
          name: "Entrar",
          title: "Entrar",
        },
      ].find(
        (page) =>
          pathname ===
          (page.path.substring(0, 1) === "/" ? page.path : `/${page.path}`)
      ),
    [pathname]
  );

  return (
    <MainLayout>
      {(sideBar ||
        (typeof currentPage?.sidebar === "boolean" &&
          currentPage?.sidebar)) && (
        <Sidebar pagePath={currentPage?.path || ""} />
      )}
      <Layout className={clsx({ expandedSidebar })}>
        {isMobile() &&
          (header ||
            (typeof currentPage?.header === "boolean" &&
              currentPage?.header)) && <Header />}
        <div className={clsx("content", "beauty-scrollbar", { overflow })}>
          {children}
        </div>
      </Layout>
    </MainLayout>
  );
};

export default PageWrapper;
